import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { DataconnectionCard } from '~src/datasource/dataConnection/components/spaces/cardView/DataconnectionCard';
import { DataConnections } from '~src/datasource/dataConnection/resources/DataConnections';
import { ContentTypeFilterClause, MixedContentItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DataConnectionContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getDataConnectionDefaultFilters } from '../../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const DataConnectionDefinition: MixedContentItemDefinition = {
  itemType: 'dataconnection',
  pluralName: Messages.connections,
  singularName: Messages.connection,
  emptyStateMessage: Messages.connectionsEmptyMessage,
  siteFilterByTypeDropdownName: () => '', // connections can be viewed as mixed content, but not as top-level content
  contentFilterKeys: DataConnectionContentType.filterKeys,
  defaultFilters: getDataConnectionDefaultFilters,
  cardComponent: DataconnectionCard,
  listViewIconType: null, // we don't display an icon for data connections
  filterClause: ServerFilterClauses.ContentType(['dataconnection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return DataConnections.all();
  },
  fieldValueResourceType: 'dataConnection',
  getContentInfo: () => {
    throw new Error('getContentInfo is not implemented for dataconnection');
  },
  supportedDisplayModes: ['list', 'thumbnail'],
};
